/**
 * 드립 한 줄 평 선택 (FR-010). 문구 데이터는 i18n 로케일(src/i18n/locales.ts)에서 온다.
 * 대상은 사무직 전반(개발 용어 배제). 항상 최소 1개 문구를 반환한다(폴백 보장).
 */
import { QUIPS, type QuipData } from '../i18n/locales';
import { LOCALE } from '../i18n/i18n';

/**
 * 성적 기반 드립 선택.
 * @param rng 0..1 난수 (기본 Math.random) — 테스트 주입용.
 * @param data 문구 데이터 (기본 현재 로케일) — 테스트 주입용.
 */
export function pickQuip(
  totalScore: number,
  maxCombo: number,
  rng: () => number = Math.random,
  data: QuipData = QUIPS[LOCALE],
): string {
  const tier = [...data.tiers].reverse().find((t) => totalScore >= t.minScore) ?? data.tiers[0];
  const line = tier.lines[Math.floor(rng() * tier.lines.length)] ?? tier.lines[0];
  const bonus = data.comboBonus.find((b) => maxCombo >= b.minCombo)?.line ?? '';
  return line + bonus;
}
